import { FC } from 'react';
import { EvaluationScoreLabel, PerformEvaluationScore, TopicScore } from '../../../commonTypes/evaluation/calculate.types';
import { ActionFooter, Button } from '../../Common';

type Props = {
    topicScores?: TopicScore[];
    responses: PerformEvaluationScore[];
    onEdit: (index: number) => void;
    onSubmit: () => void;
    onCancel: () => void;
};

const scoreConfig = {
    [EvaluationScoreLabel.NEGATIVE]: {
        label: 'Negative',
        badgeClass: 'evaluation-status-badge--negative',
    },
    [EvaluationScoreLabel.NEUTRAL]: {
        label: 'Neutral',
        badgeClass: 'evaluation-status-badge--neutral',
    },
    [EvaluationScoreLabel.POSITIVE]: {
        label: 'Positive',
        badgeClass: 'evaluation-status-badge--positive',
    },
};

export const EvaluationReview: FC<Props> = ({ topicScores, responses, onEdit, onSubmit, onCancel }) => {
    return (
        <div className="evaluation-review__container">
            <div className="evaluation-review">
                <h1>Review Evaluation</h1>
                <h3>Your responses:</h3>

                <div className="evaluation-review__grid">
                    {topicScores?.map((topicScore, index) => {
                        const score = responses[index]?.score;
                        const config = score ? scoreConfig[score] : null;

                        return (
                            <div key={index} className="evaluation-review__card">
                                <div className="evaluation-review__header">
                                    <h4 className="evaluation-review__topic-name">{topicScore.topic.name}</h4>
                                    {config ? (
                                        <div className={`evaluation-status-badge ${config.badgeClass}`}>{config.label}</div>
                                    ) : (
                                        <div className="evaluation-status-badge evaluation-status-badge--neutral">Not scored</div>
                                    )}
                                </div>

                                <p className="evaluation-review__description">
                                    {topicScore.topic.description}
                                    <br />
                                    <br />
                                    {responses[index]?.note && (
                                        <>
                                            <b>Note:</b> {responses[index].note}
                                        </>
                                    )}
                                </p>

                                <div className="evaluation-review__button">
                                    <Button text="Edit" variant="text" color="blue" onClick={() => onEdit(index)} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <ActionFooter
                buttons={[
                    {
                        text: 'Cancel',
                        onClick: onCancel,
                        variant: 'text',
                        color: 'blue',
                    },
                    {
                        text: 'Submit Evaluation',
                        onClick: onSubmit,
                        variant: 'contained',
                    },
                ]}
                className="start-evaluation-process__footer"
            />
        </div>
    );
};
